const TRACKING_CODE_PARAM_NAMES = ["order", "trackingCode"] as const;
const TRACKING_CODE_PARAM_PATTERN = /([?&])(order|trackingCode)=[^&#]*/gi;

export function redactTrackingCodeUrl(url: string): string {
  if (!TRACKING_CODE_PARAM_NAMES.some((name) => url.includes(`${name}=`))) {
    return url;
  }
  try {
    const parsed = new URL(url);
    for (const name of TRACKING_CODE_PARAM_NAMES) {
      if (parsed.searchParams.has(name)) {
        parsed.searchParams.set(name, "[REDACTED]");
      }
    }
    return parsed.toString();
  } catch {
    return url.replace(TRACKING_CODE_PARAM_PATTERN, "$1$2=[REDACTED]");
  }
}

export function redactTrackingCodeLogEvent(event: {
  view?: { url?: string };
}): boolean {
  if (event.view?.url) {
    event.view.url = redactTrackingCodeUrl(event.view.url);
  }
  return true;
}
